import PropTypes from "prop-types";
import React from "react";
import TestimonialEditIcon from "../../pages/testimonial/TestimonialEditIcon"

const TestimonialTwoSingle = ({ data, sliderClass }) => {
  return (
    <div
      className={`antera-testimonial-container single-testimonial single-testimonial--style2 text-center ${sliderClass ? sliderClass : ""
        }`}
    >
      {data.avatar != "" && data.avatar != undefined && (
        <img
          src={process.env.PUBLIC_URL + data.avatar}
          alt=""
          height="241"
          width="241"
          className="antera-testimonial-avatar"
        />
      )}
      <div className="edit-inline">
        <TestimonialEditIcon testimonialId={data._id} fromEditAction="testimonial" />
      </div>
      <p dangerouslySetInnerHTML={{ __html: data.testimonial }} style={{ paddingLeft: "30px", paddingRight: "30px" }}></p>
      <div className="antera-testimonial-client-info-container client-info">
        <div className="edit-inline">
          <TestimonialEditIcon testimonialId={data._id} fromEditAction="name" />
        </div>
        <h5 dangerouslySetInnerHTML={{ __html: data.name }}></h5>
        <div className="edit-inline">
          <TestimonialEditIcon testimonialId={data._id} fromEditAction="title" />
        </div>
        <span dangerouslySetInnerHTML={{ __html: data.title }}></span>
      </div>
    </div>
  );
};

TestimonialTwoSingle.propTypes = {
  data: PropTypes.object,
  sliderClass: PropTypes.string
};

export default TestimonialTwoSingle;
